export default "__VITE_ASSET__CM9IcY9S__"